import { CheckCircle2, Clock, ListTodo, TrendingUp } from "lucide-react";
import { Progress } from "./ui/progress";
import { cn } from "../lib/utils";

const Metric = ({ icon: Icon, label, value, accent, testId }) => (
  <div
    data-testid={testId}
    className="relative bg-white dark:bg-[#181E2C] border border-slate-200 dark:border-slate-800 rounded-xl p-5 flex items-center gap-4"
    style={{ transitionProperty: "border-color", transitionDuration: "200ms" }}
  >
    <div className={cn("h-10 w-10 rounded-lg flex items-center justify-center shrink-0", accent)}>
      <Icon className="h-5 w-5" />
    </div>
    <div className="min-w-0">
      <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 font-medium">{label}</p>
      <p className="font-display text-2xl font-bold text-slate-900 dark:text-slate-100 tabular-nums">{value}</p>
    </div>
  </div>
);

export const StatsBar = ({ summary }) => {
  const s = summary || { total: 0, todo: 0, in_progress: 0, done: 0, completion_rate: 0 };

  return (
    <div data-testid="stats-bar" className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Metric
        icon={ListTodo}
        label="Total tasks"
        value={s.total}
        accent="bg-indigo-50 text-indigo-600 dark:bg-indigo-500/15 dark:text-indigo-300"
        testId="stat-total"
      />
      <Metric
        icon={Clock}
        label="In progress"
        value={s.in_progress}
        accent="bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300"
        testId="stat-in-progress"
      />
      <Metric
        icon={CheckCircle2}
        label="Completed"
        value={s.done}
        accent="bg-emerald-50 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-300"
        testId="stat-done"
      />
      <div
        data-testid="stat-completion"
        className="relative bg-white dark:bg-[#181E2C] border border-slate-200 dark:border-slate-800 rounded-xl p-5"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 font-medium">
              Completion
            </p>
            <p className="font-display text-2xl font-bold text-slate-900 dark:text-slate-100 tabular-nums">
              {s.completion_rate}%
            </p>
          </div>
          <div className="h-10 w-10 rounded-lg flex items-center justify-center bg-fuchsia-50 text-fuchsia-600 dark:bg-fuchsia-500/15 dark:text-fuchsia-300">
            <TrendingUp className="h-5 w-5" />
          </div>
        </div>
        <Progress value={s.completion_rate} className="mt-3 h-1.5" />
      </div>
    </div>
  );
};
